import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { PackageAffectedObjectsModule } from './package-affected-objects/package-affected-objects.module';
import { PackageExceptionsModule } from './package-exceptions/package-exceptions.module';
import { PackageTagsModule } from './package-tags/package-tags.module';

import { PipelineModule } from '@app/authorized/project/pipeline/pipeline.module';
import { PackagesListComponent } from './packages-list.component';

@NgModule({
    imports: [
        SharedModule,
        PackageAffectedObjectsModule,
        PackageExceptionsModule,
        PackageTagsModule,
        PipelineModule
    ],
    declarations: [PackagesListComponent],
    entryComponents: [PackagesListComponent],
    exports: [PackagesListComponent]
})
export class PackagesListModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/packageManager/packages/packages-list/packages-list.module.ts